import $ from "jquery";
var Basic = /** @class */ (function () {
    function Basic() {
        var _this = this;
        $(window).on("scroll", function () {
            _this.scroll();
        });
        $(window).on("resize", function () {
            _this.resize();
        });
        this.animInView = [];
        $(".anim-in-view").each(function (k, el) {
            var view;
            view = {
                el: $(el),
                animDidTrigger: false,
                trigger: null
            };
            _this.animInView.push(view);
        });
        this.resize();
    }
    Basic.prototype.scroll = function () {
        this.scrollTop = $(window).scrollTop();
        this.scrollAnimInView();
    };
    Basic.prototype.resize = function () {
        this.windowHeight = $(window).height();
        this.calcAnimInView();
    };
    Basic.prototype.calcAnimInView = function () {
        var top;
        var offset;
        var trigger;
        offset = 100;
        for (var i = 0; i < this.animInView.length; i++) {
            var view;
            view = this.animInView[i];
            if (view.animDidTrigger)
                continue;
            top = view.el.offset().top + offset;
            trigger = top - this.windowHeight;
            view.trigger = trigger;
        }
        this.scroll();
    };
    Basic.prototype.scrollAnimInView = function () {
        for (var i = 0; i < this.animInView.length; i++) {
            var view;
            view = this.animInView[i];
            if (view.animDidTrigger)
                continue;
            if (this.scrollTop > view.trigger) {
                view.el.addClass("animation-triggered");
                view.animDidTrigger = true;
            }
        }
    };
    return Basic;
}());
export { Basic };
